// extracted by css-extract-rspack-plugin
var _1 = "ai";
export { _1 as "hasError" }
